import { useMediaQuery, useTheme } from '@material-ui/core'
import { components } from '../generated/schema'

type ReturnType = {
  lowerBlockAds?: components['schemas']['AdvertisingItemResource'][]
  upperBlockAds?: components['schemas']['AdvertisingItemResource'][]
  allAds?: components['schemas']['AdvertisingItemResource'][]
}

export const useNormalizeAdsData = (
  ads?: components['schemas']['AdvertisingResourceContent']
): ReturnType => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'))
  const selectedAdsType = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'

  if (!ads) {
    return { lowerBlockAds: undefined, upperBlockAds: undefined }
  }

  const upperBlockAdsInfo = {
    mobile: ads?.mobile_1,
    tablet: ads?.tablet_1,
    desktop: ads?.desktop_1920_1
  }
  const lowerBlockAdsInfo = {
    mobile: ads?.mobile_2,
    tablet: ads?.tablet_2,
    desktop: ads?.desktop_1920_2
  }
  const allBlockAdsInfo = {
    mobile: [...(ads?.mobile_1 ?? []), ...(ads?.mobile_2 ?? [])],
    tablet: [...(ads?.tablet_1 ?? []), ...(ads?.tablet_1 ?? [])],
    desktop: [...(ads?.desktop_1920_1 ?? []), ...(ads?.desktop_1920_2 ?? [])]
  }

  return {
    lowerBlockAds: lowerBlockAdsInfo[selectedAdsType],
    upperBlockAds: upperBlockAdsInfo[selectedAdsType],
    allAds: allBlockAdsInfo[selectedAdsType] as {
      image: string
      action: string
    }[]
  }
}
